import React, { Component } from "react";
import {
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  GET,
  PUT,
  alert,
  t,
} from "../../components/CustomComponent.js";

export default class GoodsIssue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_status: "",
      page: 1,
      count: 0,

      modal_issue: false,
      modal_mode: "view",
      active_issue: null,
      reject_remark: "",

      summary: {
        pending_approve: 0,
        approved: 0,
        rejected: 0,
      },

      issue_list: [],
    };
  }

  async componentDidMount() {
    loading(true);
    await this.Get();
    loading(false);
  }

  Get = async (page) => {
    const currentPage = page || this.state.page;
    if (page) this.setState({ page });
    const { filter_search, filter_status } = this.state;
    const params = { page: currentPage };
    if (filter_search) params.data_search = filter_search;
    if (filter_status) params.status = filter_status;
    const result = await GET("warehouse/goods-issues", params);

    if (result?.status) {
      this.setState({
        issue_list: result?.data?.list || [],
        summary: result?.data?.summary || this.state.summary,
        count: result?.pagination?.count || 0,
      });
    }
  };

  onSearch = async () => {
    loading(true);
    await this.Get(1);
    loading(false);
  };

  formatNumber = (num) => {
    return num?.toLocaleString() || "0";
  };

  statusView = (status) => {
    const map = {
      pending_approve: { label: t("gi_status_pending_approve"), color: "warning" },
      approved: { label: t("gi_status_approved"), color: "success" },
      ready: { label: t("gi_status_ready"), color: "success" },
      issued: { label: t("gi_status_issued"), color: "primary" },
      rejected: { label: t("gi_status_rejected"), color: "danger" },
    };
    return map[status] || { label: status || "-", color: "secondary" };
  };

  relativeTime = (value) => {
    if (!value) return "-";
    const d = new Date(String(value).replace(" ", "T"));
    if (isNaN(d.getTime())) return value;
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return t("gi_just_now");
    if (diff < 3600) return `${Math.floor(diff / 60)} ${t("gi_minutes_ago")}`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} ${t("gi_hours_ago")}`;
    return `${Math.floor(diff / 86400)} ${t("gi_days_ago")}`;
  };

  handleViewIssue = async (item, mode = "view") => {
    this.setState({ modal_issue: true, modal_mode: mode, active_issue: item });
    loading(true);
    try {
      const result = await GET("warehouse/goods-issues", { uid: item.uid });
      if (result?.status && result?.data) {
        this.setState({ active_issue: result.data });
      }
    } finally {
      loading(false);
    }
  };

  handleConfirmIssue = async () => {
    const gi = this.state.active_issue;
    if (!gi?.uid) return;
    if (!(await alert("", "question", t("confirm"), `${t("gi_confirm_issue")}?`, t("confirm"), t("cancel")))) return;

    loading(true);
    try {
      const result = await PUT(`warehouse/goods-issues/${gi.uid}/approve`, {});
      if (result?.status === true) {
        await this.Get();
        this.setState({ modal_issue: false, active_issue: null });
        alert("", "success", t("success"), t("gi_approved_success"));
      } else {
        alert("", "warning", t("warning"), result?.message || t("error"));
      }
    } finally {
      loading(false);
    }
  };

  handleRejectIssue = async () => {
    const gi = this.state.active_issue;
    if (!gi?.uid) return;
    if (!(await alert("", "question", t("confirm"), t("gi_confirm_reject"), t("confirm"), t("cancel")))) return;

    loading(true);
    try {
      const payload = {
        internal_remark: this.state.reject_remark || "",
      };
      const result = await PUT(`warehouse/goods-issues/${gi.uid}/reject`, payload);
      if (result?.status === true) {
        await this.Get();
        this.setState({ modal_issue: false, active_issue: null, reject_remark: "" });
        alert("", "success", t("success"), t("gi_rejected_success"));
      } else {
        alert("", "warning", t("warning"), result?.message || t("error"));
      }
    } finally {
      loading(false);
    }
  };

  render() {
    const { summary, issue_list, filter_search, filter_status } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarWarehouse />
        <div className="body p-4 mt-3">

          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">{t("goods_issue_title")}</h3>
            <div className="text-secondary text-14">{t("goods_issue_subtitle")}</div>
          </div>

          {/* Top Stats Cards (3 Columns) */}
          <div className="row g-3 mb-4">
            <div className="col-lg-4 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf017"}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.pending_approve)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("gi_status_pending_approve")}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf058"}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.approved)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("gi_status_approved")}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                <div className="d-flex align-items-center">
                  <div className="wpx-40 hpx-40 me-3 rounded-3 bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">
                    {"\uf05e"}
                  </div>
                  <div>
                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.rejected)}</h3>
                    <div className="text-secondary text-12 fw-bold">{t("gi_status_rejected")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filter + Table Card */}
          <div className="bg-white rounded-4 shadow-sm p-4">

            {/* Filter Bar */}
            <div className="border-bottom border-light d-flex flex-wrap justify-content-between align-items-center gap-3 pb-3 mb-3">
              <div className="d-flex gap-3 flex-wrap flex-grow-1">
                <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-300"
                    style={{ height: "38px" }}
                    placeholder={t("search")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                    onKeyDown={(e) => e.key === "Enter" && this.onSearch()}
                  />
                </div>
                <select
                  className="form-select wpx-180"
                  style={{ height: "38px" }}
                  value={filter_status}
                  onChange={(e) => this.setState({ filter_status: e.target.value })}
                >
                  <option value="">{t("gi_all_status")}</option>
                  <option value="pending_approve">{t("gi_status_pending_approve")}</option>
                  <option value="approved">{t("gi_status_approved")}</option>
                  <option value="rejected">{t("gi_status_rejected")}</option>
                </select>
                <div className="d-flex gap-2">
                  <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={this.onSearch}>
                    {t("filter")}
                  </button>
                  <button
                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                    onClick={() => this.setState({ filter_search: "", filter_status: "" }, this.onSearch)}
                  >
                    {t("clear_all")}
                  </button>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1400px" }}>
                <thead>
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                    <th className="py-3 px-2 border-0">{t("gi_number")}</th>
                    <th className="py-3 border-0">{t("gi_type")}</th>
                    <th className="py-3 border-0">{t("gi_reference")}</th>
                    <th className="py-3 border-0">{t("gi_customer")}</th>
                    <th className="py-3 border-0">{t("gi_requester")}</th>
                    <th className="py-3 border-0 text-center">{t("gi_quantity")}</th>
                    <th className="py-3 border-0">{t("gi_requested_time")}</th>
                    <th className="py-3 border-0 text-center">{t("gi_priority")}</th>
                    <th className="py-3 border-0 text-center">{t("status")}</th>
                    <th className="py-3 border-0 text-center">{t("gi_actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {issue_list.length === 0 ? (
                    <tr>
                      <td colSpan={10} className="text-center text-secondary py-5">{t("gi_empty")}</td>
                    </tr>
                  ) : (
                    issue_list.map((item, idx) => {
                      const sv = this.statusView(item.status);
                      const priorityStyle = {
                        backgroundColor: item.priority_bg_color || "#E5E7EB",
                        color: item.priority_font_color || "#374151",
                      };
                      return (
                        <tr key={idx} className="border-bottom border-light">
                          <td className="py-3 px-2">
                            <span className="fw-bold text-primary text-14 pointer hover-underline">{item.iat_number || "-"}</span>
                          </td>
                          <td>
                            <span className="badge bg-light text-secondary border rounded-pill px-3 py-1 fw-bold text-10">{t("gi_type_wo")}</span>
                          </td>
                          <td className="text-dark text-14">{item.wo_number || "-"}</td>
                          <td className="text-dark text-14">{item.customer_name || "-"}</td>
                          <td className="text-secondary text-14">{item.requester || "-"}</td>
                          <td className="text-center fw-bold text-dark text-14">{item.total_quantity ?? 0}</td>
                          <td className="text-secondary text-14">{this.relativeTime(item.requested_at)}</td>
                          <td className="text-center">
                            <span className="badge rounded-pill fw-bold text-12 px-3 py-1" style={priorityStyle}>
                              {item.priority || t("gi_priority_normal")}
                            </span>
                          </td>
                          <td className="text-center">
                            <span className={`badge bg-${sv.color}-light text-${sv.color} rounded-pill px-3 py-1 fw-bold text-10 border border-${sv.color}`}>
                              {sv.label}
                            </span>
                          </td>
                          <td className="text-center">
                            <div className="d-flex align-items-center justify-content-center gap-3">
                              <span className="icon text-secondary pointer" title={t("view")} onClick={() => this.handleViewIssue(item)}>
                                {"\uf06e"}
                              </span>
                              <span
                                className={`icon ${item.status === "pending_approve" ? "text-success pointer" : "text-muted"}`}
                                title={t("gi_issue_action")}
                                style={item.status === "pending_approve" ? undefined : { opacity: 0.4, cursor: "not-allowed" }}
                                onClick={item.status === "pending_approve" ? () => this.handleViewIssue(item, "issue") : undefined}
                              >
                                {"\uf04b"}
                              </span>
                              {/* <span className="icon text-secondary pointer" title={t("print")}>
                                {"\uf02f"}
                              </span> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer Pagination */}
            <div className="d-flex justify-content-between align-items-center pt-3 border-top border-light flex-wrap text-secondary text-12">
              <div>
                {t("showing")} 1-{issue_list.length} {t("of")} {this.formatNumber(this.state.count)} {t("items")}
              </div>
              <div className="d-flex align-items-center gap-3">
                <Pagination
                  className="mb-0"
                  count={Math.ceil((this.state.count || 0) / 10) || 1}
                  page={this.state.page}
                  showFirstButton={false}
                  showLastButton={false}
                  onChange={(_, page) => { loading(true); this.Get(page).then(() => loading(false)); }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Modal: รายละเอียดรายการเบิกอะไหล่ (ดำเนินการจ่าย) */}
        <Modal show={this.state.modal_issue} onHide={() => this.setState({ modal_issue: false, active_issue: null, reject_remark: "" })} size="lg" centered>
          {this.state.active_issue && (() => {
            const gi = this.state.active_issue;
            const { modal_mode, reject_remark } = this.state;
            const sv = this.statusView(gi.status);
            const priorityStyle = {
              backgroundColor: gi.priority_bg_color || "#E5E7EB",
              color: gi.priority_font_color || "#374151",
            };
            return (
              <>
                <Modal.Header className="bg-white border-bottom px-4 py-3">
                  <Modal.Title className="fw-bold text-dark text-18">No: {gi.iat_number || "-"}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                  <div className="row g-3 mb-4">
                    <div className="col-6">
                      <div className="text-12 text-secondary mb-1">{t("gi_type")}</div>
                      <span className="badge bg-primary-light text-primary rounded-pill px-3 py-1 fw-bold">{t("gi_type_wo")}</span>
                    </div>
                    <div className="col-6">
                      <div className="text-12 text-secondary mb-1">{t("status")}</div>
                      <span className={`badge bg-${sv.color}-light text-${sv.color} rounded-pill px-3 py-1 fw-bold`}>{sv.label}</span>
                    </div>
                    <div className="col-6">
                      <div className="text-12 text-secondary mb-1">{t("gi_reference")}</div>
                      <div className="fw-bold text-dark">{gi.wo_number || "-"}</div>
                    </div>
                    <div className="col-6">
                      <div className="text-12 text-secondary mb-1">{t("gi_priority")}</div>
                      <span className="badge rounded-pill fw-bold px-3 py-1" style={priorityStyle}>{gi.priority || t("gi_priority_normal")}</span>
                    </div>
                    <div className="col-6">
                      <div className="text-12 text-secondary mb-1">{t("gi_customer")}</div>
                      <div className="fw-bold text-dark">{gi.customer_name || "-"}</div>
                    </div>
                    <div className="col-6">
                      <div className="text-12 text-secondary mb-1">{t("gi_requester")}</div>
                      <div className="fw-bold text-dark">{gi.requester || "-"}</div>
                    </div>
                    <div className="col-12">
                      <div className="text-12 text-secondary mb-1">{t("gi_requested_time")}</div>
                      <div className="fw-bold text-dark">{this.relativeTime(gi.requested_at)}</div>
                    </div>
                  </div>

                  <div className="fw-bold text-dark mb-2">{t("gi_items")} ({(gi.items || []).length})</div>
                  <div className="table-responsive">
                    <table className="table table-sm align-middle mb-0">
                      <thead>
                        <tr className="text-secondary text-12 border-bottom">
                          <th>{t("gi_part_code")}</th>
                          <th>{t("gi_part_name")}</th>
                          <th>{t("gi_lot_no")}</th>
                          <th>{t("uom")}</th>
                          <th className="text-center">{t("gi_quantity")}</th>
                          <th>{t("gi_warehouse")}</th>
                          <th>{t("gi_location")}</th>
                        </tr>
                      </thead>
                      <tbody className="text-14">
                        {(gi.items || []).map((it, i) => {
                          const lotParts = (it.lot || "").split(" / ");
                          const lotNumber = lotParts[0] || "-";
                          const warehouse = lotParts[1] || "-";
                          const location = lotParts[2] || "-";
                          return (
                            <tr key={i}>
                              <td><span className="fw-bold text-primary">{it.part_number || "-"}</span></td>
                              <td className="text-dark">{it.part_name || "-"}</td>
                              <td>{lotNumber}</td>
                              <td>{it.uom_name || "-"}</td>
                              <td className="text-center fw-bold text-dark">{it.quantity ?? "-"}</td>
                              <td>{warehouse}</td>
                              <td>{location}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {modal_mode === "issue" && gi.status === "pending_approve" && (
                    <div className="mt-3 pt-3 border-top border-light">
                      <div className="text-12 text-secondary mb-1 fw-bold">{t("gi_reject_remark")}</div>
                      <textarea
                        className="form-control"
                        rows={3}
                        placeholder={t("gi_reject_remark_placeholder")}
                        value={reject_remark}
                        onChange={(e) => this.setState({ reject_remark: e.target.value })}
                      />
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
                  {modal_mode === "issue" && gi.status === "pending_approve" && (
                    <>
                      <button className="btn btn-danger px-4 py-2 rounded-3 fw-bold d-inline-flex align-items-center" onClick={this.handleRejectIssue}>
                        <span className="icon me-2">{"\uf05e"}</span> {t("reject")}
                      </button>
                      <button className="btn btn-success px-4 py-2 rounded-3 fw-bold d-inline-flex align-items-center" onClick={this.handleConfirmIssue}>
                        <span className="icon me-2">{"\uf0d1"}</span> {t("gi_confirm_issue")}
                      </button>
                    </>
                  )}
                  <button className="btn btn-secondary px-4 py-2 rounded-3 fw-bold" onClick={() => this.setState({ modal_issue: false, active_issue: null })}>
                    {t("close")}
                  </button>
                </Modal.Footer>
              </>
            );
          })()}
        </Modal>
      </div>
    );
  }
}
